// extracted by mini-css-extract-plugin
export default {"orderTableButtonsHeaderContainer":"WT-z","validationButton":"XT-z","disabled":"YT-z","loader":"ZT-z","info":"_T-z","tooltipCta":"aU-z","tooltip":"bU-z"};